var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:[
        {
            'form-row': _vm.horizontal,
        } ]},[(_vm.label)?_c('label',{class:[
            { 'col-form-label': _vm.horizontal },
            _vm.horizontal ? _vm.class_label : '',
            _vm.size == 'sm' ? 'col-form-label-sm' : '' ]},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',{class:[
            _vm.horizontal ? _vm.class_input : '',
            _vm.size == 'sm' ? 'input-group-sm' : '',
            'd-flex', 'align-items-center' ]},[_c('CSwitch',{attrs:{"checked":_vm.checkedComponent,"name":_vm.name,"color":_vm.color,"shape":"pill","variant":"3d","size":_vm.size},on:{"update:checked":function($event){_vm.checkedComponent=$event}}}),(_vm.isValid == false)?_c('div',{staticClass:"invalid-feedback"},[_vm._v(" "+_vm._s(_vm.invalidFeedback)+" ")]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }